import { Button } from '#/components/ui/button';
import { Link } from 'react-router';

import { SiteGuideAnchorNav } from '../components/site-guide-anchor-nav';
import { SiteGuideList } from '../components/site-guide-list';
import { SiteTickerScroll } from '../components/site-ticker-scroll';
import { buttonStyles } from '../styles';
import { SvgGuideIllustDifference } from '../svg/img-guide-illust-difference';
import { SvgGuideIllustKabukatsu } from '../svg/img-guide-illust-kabukatsu';
import { SvgGuideMainTitle } from '../svg/img-guide-main-title';
import { SvgGuideTicket } from '../svg/img-guide-tickect';
import { metaTitle } from '../utils/meta-title';
import { useAnchorSmoothScroll } from '../utils/use-anchor-smooth-scroll';
import type { Route } from './+types/guide';

export const meta: Route.MetaFunction = () => {
  return [{ title: metaTitle('カブ活ご利用ガイド') }];
};

export default function Guide() {
  useAnchorSmoothScroll(135);

  return (
    <>
      <div>
        <div className="relative">
          <img src="/images/guide/kv.png" alt="カブ活ガイドメインビジュアル" className="w-full" />
        </div>
        <section className="bg-grey-50 relative z-0">
          <h1 className="relative mx-auto mb-6 overflow-hidden pt-1.5 pr-2 pb-2 pl-2">
            <SvgGuideMainTitle className="h-auto w-full" aria-label="カブ活でもっと株をもらおう" />
            <SvgGuideTicket
              className="absolute top-[calc(100vw*135/767)] right-[0] h-auto w-[calc(100vw*149/767)] md:top-[130px] md:w-[143px]"
              aria-label="カブ活チケットイラスト"
            />
          </h1>
          <Link to="/" className="mx-auto mb-[122px] block w-[250px]">
            <Button className={buttonStyles.default.lg}>さっそくカブ活をする</Button>
          </Link>

          <SiteTickerScroll width={218} repeat={6} />

          <div className="relative mx-auto block max-w-screen-lg items-start px-4 pt-18 pb-8">
            <div className="w-full">
              <p className="text-body-s-bold text-brand mb-4 pt-4 text-center">KAB&カブ活とは</p>
              <div>
                <h2 className="text-headline-xl mb-7 text-center">
                  いつものお買い物や
                  <br />
                  ゲーム・サービス利用で
                  <br />
                  株がもらえる。
                </h2>
                <SvgGuideIllustKabukatsu
                  className="mx-auto w-[min(345px,calc(100vw-3rem))]"
                  aria-label="カブ活イラスト"
                />
              </div>
            </div>
          </div>

          <div className="mx-4 max-w-screen-md rounded-lg bg-white px-4 py-10">
            <section className="space-y-6">
              <h3 className="text-headline-m">カブ活とポイ活の違いは？</h3>
              <div className="space-y-2">
                <p className="text-body-m">
                  ポイ活でもらえるポイントの価値は、1ポイント1円とそのまま、一方、カブ活でもらえる株はカブアンド社の成長と共に価値が上がるかもしれません。
                </p>
              </div>
              <div className="bg-grey-50 relative overflow-hidden rounded-2xl px-4 pt-8 pb-4">
                <SvgGuideIllustDifference
                  className="mx-auto h-auto w-full max-w-[347px]"
                  aria-label="カブ活とポイ活の違いイラスト"
                />
              </div>
              <p className="text-caption-m text-grey-500 before:text-caption-m relative pl-6 before:absolute before:left-0 before:content-['※']">
                上図はイメージであり、実際の株式の価値の動きとは異なります。また、株式の価値が株交換時の発行価格よりも下落するリスクがあります。
              </p>
            </section>
          </div>
          <SiteGuideAnchorNav />

          <section className="overflow-hidden overflow-x-clip overflow-y-visible bg-white pt-[120px]">
            <div className="mx-auto w-full overflow-hidden px-4">
              <SiteGuideList />
            </div>
          </section>
        </section>
      </div>
    </>
  );
}
